import { __assign, __extends, __rest } from "tslib";
import React, { Component } from 'react';
import { noop } from 'lodash';
import { Box } from '../Box';
import { createComponent } from '../utils';
import Checkbox from './Checkbox';
import Label from './Label';
import { FormError } from './FormError';
import { createEasyInput } from './EasyInput';
import GroupContainer from './GroupContainer';
var StyledRadioGroup = createComponent({
    name: 'RadioGroup',
    as: Box,
});
var RadioGroup = (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: _this.props.value || null,
        };
        _this.handleChange = function (_field, value) {
            if (_this.state.value === value) {
                return;
            }
            _this.setState({ value: value }, function () {
                _this.props.onChange(_this.props.name, value);
            });
        };
        return _this;
    }
    RadioGroup.getDerivedStateFromProps = function (props, state) {
        if (props.value !== undefined && props.value !== state.value) {
            return {
                value: props.value,
            };
        }
        return null;
    };
    RadioGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, choices = _a.choices, error = _a.error, horizontal = _a.horizontal, label = _a.label, name = _a.name, colorFocus = _a.colorFocus, checkboxProps = __rest(_a, ["choices", "error", "horizontal", "label", "name", "colorFocus"]);
        return (React.createElement(StyledRadioGroup, null,
            label && React.createElement(Label, null, label),
            React.createElement(GroupContainer, { horizontal: horizontal }, choices.length &&
                choices.map(function (choice) {
                    var _a = choice.value, value = _a === void 0 ? choice.id : _a, choiceLabel = choice.label;
                    var key = "RadioButton-" + name + "-" + value;
                    return (React.createElement(Checkbox, __assign({}, checkboxProps, { id: key, key: key, name: key, horizontal: horizontal, label: choiceLabel, value: _this.state.value, valueTrue: value, valueFalse: value, onChange: _this.handleChange, colorFocus: colorFocus, isRadio: true })));
                })),
            !!error && React.createElement(FormError, null, error)));
    };
    RadioGroup.defaultProps = {
        choices: [],
        onChange: noop,
        styles: {},
        iconOn: 'radiobox-marked',
        iconOff: 'radiobox-blank',
    };
    return RadioGroup;
}(Component));
export { RadioGroup };
export default createEasyInput(RadioGroup);
//# sourceMappingURL=RadioGroup.js.map